var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input-number',_vm._b({attrs:{"value":_vm.$props.value},on:{"change":_vm.change,"input":_vm.input}},'el-input-number',_vm.overrideAttrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }